module.exports = __webpack_public_path__ + "img/GR118.3089f202.svg";